// extracted by mini-css-extract-plugin
module.exports =  {"collect-wrapper":"fqvyWvp","collectWrapper":"fqvyWvp","collect-btn":"CY9JiK3","collectBtn":"CY9JiK3","collected":"Vg2sOJF"};